import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const components = {
  p: (props) => <p className="my-2" {...props} />,
  strong: (props) => <strong className="font-semibold text-white" {...props} />,
  ul: (props) => <ul className="my-2 list-disc space-y-1 pl-5" {...props} />,
  ol: (props) => <ol className="my-2 list-decimal space-y-1 pl-5" {...props} />,
  h1: (props) => <h3 className="mb-2 mt-4 font-display text-lg text-white" {...props} />,
  h2: (props) => <h3 className="mb-2 mt-4 font-display text-lg text-white" {...props} />,
  h3: (props) => <h4 className="mb-1 mt-3 font-semibold text-white" {...props} />,
  table: (props) => (
    <div className="my-3 overflow-x-auto">
      <table className="w-full border-collapse text-[13px]" {...props} />
    </div>
  ),
  th: (props) => <th className="border border-white/15 bg-white/5 px-3 py-1.5 text-left font-semibold" {...props} />,
  td: (props) => <td className="border border-white/10 px-3 py-1.5 align-top" {...props} />,
  code: (props) => <code className="rounded-sm bg-white/10 px-1 py-0.5 font-mono text-[13px]" {...props} />,
  a: (props) => <a className="text-accent-blue-light underline" target="_blank" rel="noreferrer" {...props} />,
};

export const MarkdownMessage = ({ children }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
    {children || ""}
  </ReactMarkdown>
);
